export const generativeAiAgentsCampaignQa = "/:app_group_id/generative_ai/agents/campaign_qa";
